export const API_KEY = "OvviFG5Axzh5u8pzekrY0UtrIwnEO2JLK7MhgBDK";
export const ENDPOINT  = "https://quizapi.io/api/v1";